import DataPointsLib from '@retracedgmbh/data-points-lib'

const dataPointsLib = new DataPointsLib({})
const dataPoints = dataPointsLib.initializeDataPoints()

export default dataPoints
